import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/hooks';
import { selectnetworksQueryItems } from '../../../../../redux/networks/selector';
import { networks } from '../../../../../redux/networks/action';
import NetworkComponent from '../components/network.component';
import { deepCopy } from '../../../../../common/services/common.service';
import { selectCurrent } from '../../../../../redux/settings/selectors';
import { settings } from '../../../../../redux/settings/actions';
import UploadFiles from '../../../../../models/UploadFile';
import PageLoader from '../../../../../components/PageLoader';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { domains } from '../../../../../redux/domains/action';

let currentChange: any = {}
const Network= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectnetworksQueryItems)
  const { getUploadFiles } = useAppSelector(selectCurrent)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const domainItems = useSelector(selectDomainsListItems)
  
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedNetwork,
    setSelectedNetwork
  ] = useState<any>({Name: '',
    DomainId: 0,
    Description:'',
    IsOrganizationNetwork:false,
    MediaMappings: {
      MediaFiles: [],
      Templates: []
    }
  })
  const [
    networkImageIndex,
    setNetworkImageIndex
  ] = useState<any>([])
  const [
    mediaFiles,
    setMediaFiles
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
 
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(mediaFiles);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setMediaFiles(items);
  }


  const fetchNetworkById= ()=>{
    dispatch(networks.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/query`,entity:'networks',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedNetwork({ ...selectedNetwork, [field]: event });
  }

  useEffect(
    () => {
      dispatch(domains.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
        entity: 'domains',
        jsonData: {}
    })).then(()=>{
      if (parmas?.id > 0) {
        fetchNetworkById()
        setIsLoading(false)
    }else {
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
        setMediaFiles(localSelectedMedia)
        setIsLoading(false)
      }
    })},
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedNetwork(queryItems?.result?.items)
        const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryItems?.result?.items?.MediaMappings?.MediaFiles });
        setMediaFiles(localSelectedMedia)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
        mediaFiles.length - 1,
        1
      )
    if (parmas?.id > 0) {
      await dispatch(networks.resetAction({ actionType: 'update' }))
    await dispatch(networks.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks`,entity:'networks',jsonData:{
          
    Records: [
      {
        
       
         ...selectedNetwork
        
    
     
    }
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(networks.resetAction({ actionType: 'create' }))
      await dispatch(networks.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks`,entity:'networks',jsonData:{
          
      Records: [
        {
        
         
            ...selectedNetwork
          
      
       
      }
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/dbaas/networks')
} 
const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
    const localSelectedmedia = deepCopy(selectedMediaFilesArg)
    const newsSelectedMedia = {
      Id: 0,
      FileTypeId: 0,
      OwnerTypeId: 144,
      FileMappingURL: ''
    }
    if (localSelectedmedia.length === 0 ||
      localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
    ) {
      localSelectedmedia?.push(newsSelectedMedia)
    }
  
    return localSelectedmedia
  }
  const setCombinationInfo = async () => {
    let localSelectedMedia = deepCopy(mediaFiles)
    localSelectedMedia.splice(
      currentChange.idx,
      1,
      { ...localSelectedMedia[currentChange.idx] }
    );
    localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
    currentChange.field = 'FileTypeIdDONE'
    setMediaFiles(localSelectedMedia)
  }
  const changeImage = (idx: number, templateField: any, fileType: any) => {
    setNetworkImageIndex(idx)
    dispatch(settings.set({ getUploadFiles: 'open' }))
    setOpenFile({
      currentFileSrc: mediaFiles[idx][templateField],
      folder: 'network',
      type: fileType
    })
  }
  const handleSubmit = (data: any) => {
  
    mediaFiles[networkImageIndex].FileMappingURL = data
    const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
    setMediaFiles(localSelectedMedia)
  }
  const handleClose = () => {
    dispatch(settings.set({ getUploadFiles: 'close' }))
    
  }
  
  useEffect(
    () => {
      if (currentChange.field === 'FileTypeId') {
        setCombinationInfo()
      }
    },
    [mediaFiles]
  )
  
    return (
    <>
     {getUploadFiles == 'open' && <UploadFiles  currentFilesSrc={openFile?.currentFileSrc}
    folder={openFile?.folder}
         handleClose={handleClose}
         handleFilesSubmit={handleSubmit}
         type={openFile?.type}
         />}
    {isLoading ? <PageLoader /> : 
          <NetworkComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedNetwork={selectedNetwork}
           back={back}
           handleFormSubmit={handleFormSubmit}
           changeImage={changeImage}
           mediaFiles={mediaFiles}
           handleFormItemChange={handleFormItemChange}
           domainDetails={domainItems?.result?.items}
          />  
        }
    
          </>
    )
    
    }
   
    export default Network;
